import { useMemo, useState } from "react";

const useHeaderToggle = () => {
  const [visible, setVisible] = useState(false);

  return useMemo(
    () => ({
      visible,
      toggle: (show) => {
        setVisible((prevState) => (show === undefined ? !prevState : show));
      },
    }),
    [visible]
  );
};

export default useHeaderToggle;
